import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class RackZoneDtoActive{
    @ApiProperty()
    rackZoneMappingId:number;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    updatedUser : string;



}